"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTime = formatTime;
exports.wrapBg = wrapBg;
exports.formatDate = formatDate;
exports.groupBy = exports.sortBy = exports.sumArray = exports.roundedNumber = exports.snakeCasify = exports.snakeToCamel = exports.capitalizeString = exports.validateURL = exports.validateDate = exports.validatePct = exports.validateNumber = exports.validateString = exports.sortAlphabetical = exports.sortList = exports.randomIntegerIn = exports.sentimentValueToColor = exports.objectToSortedArray = exports.numberWithCommas = exports.spectrum = exports.linSpace = exports.getHSL = exports.roundDecimal = exports.inPercent = exports.toQueryObject = exports.toQueryString = exports.removeKeysFromObject = exports.isObjectEmpty = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @desc Formats time in secs to hours, mins, secs
 * @param  {Number} secs The number of seconds to convert.
 * @return {String} Time in hours, mins, secs.
 */
function formatTime(secs) {
  if (secs === undefined) {
    return '0s';
  }

  var d = Math.floor(secs / (3600 * 24));
  secs -= d * 3600 * 24;
  var h = Math.floor(secs / 3600);
  secs -= h * 3600;
  var m = Math.floor(secs / 60);
  secs -= m * 60;
  var tmp = [];
  d && tmp.push("".concat(d, "d"));
  (d || h) && tmp.push("".concat(h, "h"));
  (d || h || m) && tmp.push("".concat(m, "m"));
  tmp.push("".concat(Math.floor(secs), "s"));
  return tmp.join(' ');
}

function wrapBg(img) {
  return img ? {
    backgroundImage: "url('".concat(img, "')")
  } : null;
}

var isObjectEmpty = function isObjectEmpty(obj) {
  var key;

  for (key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }

  return true;
};
/**
 * Removes the keys inside the fields array from the given object
 * @param {Object} obj
 * @param {Array} fields
 * @return {Object}
 */


exports.isObjectEmpty = isObjectEmpty;

var removeKeysFromObject = function removeKeysFromObject(obj, fields) {
  return Object.keys(obj).filter(function (key) {
    return !fields.includes(parseInt(key, 10));
  }).reduce(function (newObj, key) {
    return _objectSpread({}, newObj, _defineProperty({}, key, obj[key]));
  }, {});
};

exports.removeKeysFromObject = removeKeysFromObject;

var toQueryString = function toQueryString(obj) {
  var parts = [];

  for (var i in obj) {
    if (obj.hasOwnProperty(i) && obj[i] && encodeURIComponent(obj[i]).length) {
      parts.push("".concat(encodeURIComponent(i), "=").concat(encodeURIComponent(obj[i])));
    }
  }

  return parts.join('&');
};

exports.toQueryString = toQueryString;

var toQueryObject = function toQueryObject(str) {
  // remove any preceding url and split
  str = str.substring(str.indexOf('?') + 1).split('&');
  var params = {};
  var pair;
  var d = decodeURIComponent; // march and parse

  for (var i = str.length - 1; i >= 0; i--) {
    pair = str[i].split('=');
    var key = d(pair[0]);
    var value = d(pair[1]);

    if (key.indexOf('[]') !== -1) {
      key = key.replace('[]', '');

      if (params[key]) {
        params[key].push(value);
      } else {
        params[key] = [value];
      }
    } else {
      params[d(pair[0])] = d(pair[1] || '');
    }
  }

  return params;
};
/**
 * Return the percentual representation of a number.
 * @param  {Number} number        The number to convert.
 * @param  {Number} [decimals=1]  Maximum decimals to represent.
 * @return {String}               Given number in percentual + %.
 * @example
 * inPercent(0.1);
 * // Returns '10%'
 * inPercent(0.0001);
 * // Returns '0%'
 * inPercent(0.10001, 3);
 * // Returns '10.001%'
 */


exports.toQueryObject = toQueryObject;

var inPercent = function inPercent(number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var roundFactor = Math.pow(10, decimals);
  var roundedNumber = Math.round(number * roundFactor * 100) / roundFactor;
  return "".concat(roundedNumber, "%");
};

exports.inPercent = inPercent;

var roundDecimal = function roundDecimal(number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (typeof number !== 'number') {
    return null;
  }

  var roundFactor = Math.pow(10, decimals);
  return Math.round(number * roundFactor) / roundFactor;
};

exports.roundDecimal = roundDecimal;

var getHSL = function getHSL(string) {
  return string.match(/\d+/g).map(Number);
};

exports.getHSL = getHSL;

var linSpace = function linSpace(n) {
  return _toConsumableArray(Array(n).keys()).map(function (i) {
    return i / n;
  });
};
/**
 * Return a spectrum of N colors between two given colors.
 * @param  {String} from    Starting color in HSL.
 * @param  {String} to      Ending color in HSL.
 * @param  {Number} colors  Number of colors to return.
 * @return {Array.String}   Array of HSL colors.
 * @example
 * spectrum({ from: 'hsl(344, 97%, 60%)', to: 'hsl(390, 94%, 99%)', colors: 5 });
 * // Returns
 * // [ 'hsl(344, 97%, 60%)',
 * //   'hsl(353.2, 96.4%, 67.8%)',
 * //   'hsl(362.4, 95.8%, 75.6%)',
 * //   'hsl(371.6, 95.2%, 83.4%)',
 * //   'hsl(380.8, 94.6%, 91.2%)' ]
 */


exports.linSpace = linSpace;

var spectrum = function spectrum(_ref) {
  var from = _ref.from,
      to = _ref.to,
      colors = _ref.colors;

  var _getHSL = getHSL(from),
      _getHSL2 = _slicedToArray(_getHSL, 3),
      fH = _getHSL2[0],
      fS = _getHSL2[1],
      fL = _getHSL2[2];

  var _getHSL3 = getHSL(to),
      _getHSL4 = _slicedToArray(_getHSL3, 3),
      tH = _getHSL4[0],
      tS = _getHSL4[1],
      tL = _getHSL4[2];

  var dH = tH - fH,
      dS = tS - fS,
      dL = tL - fL;
  return linSpace(colors).map(function (i) {
    var iH = fH + dH * i;
    var iS = fS + dS * i;
    var iL = fL + dL * i;
    return "hsl(".concat(iH, ", ").concat(iS, "%, ").concat(iL, "%)");
  });
}; // Format numbers with commas


exports.spectrum = spectrum;

var numberWithCommas = function numberWithCommas(number) {
  if (typeof number === 'number') {
    return roundDecimal(number).toLocaleString();
  }

  return null;
}; // ... turns a {key:value} object in a [{name:key, value: value}] array


exports.numberWithCommas = numberWithCommas;

var objectToSortedArray = function objectToSortedArray(object) {
  if (object) {
    return Object.keys(object).map(function (key) {
      return {
        name: key,
        value: object[key]
      };
    }).sort(function (a, b) {
      return b.value - a.value;
    });
  }

  return [];
};
/**
 * @desc Returns hex codes for sentiment values
 * @param {Number} value The value (from 0 to 20) to convert.
 * @return {String} The Hex string for color for corresponding sentiment value
 */


exports.objectToSortedArray = objectToSortedArray;

var sentimentValueToColor = function sentimentValueToColor(value) {
  var colors = {
    0: '#5ca7ce',
    2: '#74b4d7',
    4: '#93c5de',
    6: '#b3d6e9',
    8: '#d1e7f2',
    10: '#b3b3b3',
    12: '#fe9fa3',
    14: '#fb7576',
    16: '#fc5e6c',
    18: '#fa4b6c',
    20: '#fc376c'
  };
  return colors[value];
};
/**
 * @desc Generate a random whole number within [low, high).
 * @param {Number} low Lower bound (inlcusive)
 * @param  {Number} high Upper bound (exclusive)
 * @return {Number} The desired random number
 */


exports.sentimentValueToColor = sentimentValueToColor;

var randomIntegerIn = function randomIntegerIn(low, high) {
  return Math.floor(low + Math.random() * (high - low));
};
/**
 * @desc Sort ranges in chosen direction
 * @param {String} unit used for sorting
 * @param {String} direction
 */


exports.randomIntegerIn = randomIntegerIn;

var sortList = function sortList(unit, direction) {
  return function (a, b) {
    var dirIndex = 0;
    if (direction === 'ascending') dirIndex = 1;
    if (direction === 'descending') dirIndex = -1;
    return (parseInt(a[unit], 10) - parseInt(b[unit], 10)) * dirIndex;
  };
};

exports.sortList = sortList;

var sortAlphabetical = function sortAlphabetical(unit, direction) {
  return function (a, b) {
    if (a[unit] && b[unit]) {
      var valA = a[unit].toLowerCase();
      var valB = b[unit].toLowerCase();

      if (direction === 'descending') {
        if (valA < valB) return -1;
        if (valA > valB) return 1;
        return 0;
      }

      if (valA > valB) return -1;
      if (valA < valB) return 1;
      return 0;
    }

    return false;
  };
};
/**
 * @desc Formats a JS Date object into a human readable String
 * @param {Date} date
 * @param {Object} options
 * @return {String}
 */


exports.sortAlphabetical = sortAlphabetical;

function formatDate(date) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (options["short"]) {
    return (0, _moment["default"])(date).utc(false).format('MM/DD/YY');
  }

  return (0, _moment["default"])(date).utc(false).format('Do MMMM YYYY');
}
/**
 * @desc Simple validation functions
 * @param {String} data
 * @return {Boolean}
 */


var validateString = function validateString(data) {
  return !!data && typeof data === 'string' && data.length > 0;
};
/**
 * @desc Simple validation functions
 * @param {Number} data
 * @return {Boolean}
 */


exports.validateString = validateString;

var validateNumber = function validateNumber(data) {
  return !isNaN(data) && typeof data === 'number';
};
/**
 * @desc Simple validation percentage number between 0 & 1
 * @param {Number} data
 * @return {Boolean}
 */


exports.validateNumber = validateNumber;

var validatePct = function validatePct(data) {
  return validateNumber(data) && data >= 0 && data <= 1;
};
/**
 * @desc vali-Date? Validate date string
 * @param {Date} data
 * @return {Boolean}
 */


exports.validatePct = validatePct;

var validateDate = function validateDate(data) {
  return !!data && !isNaN(Date.parse(data));
};
/**
 * @desc Check if a URL is relatively correct.
 * @param {Date} data
 * @return {Boolean}
 */


exports.validateDate = validateDate;

var validateURL = function validateURL(url) {
  return /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?.*$/.test(url);
};
/**
 * @desc capitalize first letter of string
 */


exports.validateURL = validateURL;

var capitalizeString = function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
};
/**
 * @desc snake case to camel case
 */


exports.capitalizeString = capitalizeString;

var snakeToCamel = function snakeToCamel(object) {
  var result = {};

  for (var field in object) {
    var camelField = '';
    var value = _typeof(object[field]) === 'object' ? snakeToCamel(object[field]) : object[field];
    var fieldArray = field.split('_');

    for (var i = 0; i < fieldArray.length; i++) {
      camelField += i === 0 ? fieldArray[i] : capitalizeString(fieldArray[i]);
    }

    result[camelField] = value;
  }

  return result;
};

exports.snakeToCamel = snakeToCamel;

var snakeCasify = function snakeCasify(data) {
  var update = {};

  for (var field in data) {
    update[(0, _lodash.snakeCase)(field)] = data[field];
  }

  return update;
};
/**
 * @desc converts 12345 to 12.3k
 */


exports.snakeCasify = snakeCasify;

var roundedNumber = function roundedNumber(num, fixed) {
  if (num === null || num === undefined) {
    return null;
  }

  if (num === 0) {
    return '0';
  }

  fixed = !fixed || fixed < 0 ? 0 : fixed;
  var b = num.toPrecision(2).split('e');
  var k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3);
  var c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed);
  var d = c < 0 ? c : Math.abs(c);
  var e = d + ['', 'k', ' M', 'b', 't'][k];
  return e;
};
/**
 * @desc Helper to get sum of array of data
 */


exports.roundedNumber = roundedNumber;

var sumArray = function sumArray(array) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  return array.reduce(function (acc, curr) {
    return acc + curr[unit];
  }, 0);
};
/**
 *
 * @desc returns function to use in arr.sort to sort by an object value
 * @param {*} property string
 */


exports.sumArray = sumArray;

var sortBy = function sortBy(property, order) {
  return function (a, b) {
    var descending = order === 'DESC';

    if (a[property] < b[property]) {
      return descending ? 1 : -1;
    }

    if (a[property] > b[property]) {
      return descending ? -1 : 1;
    }

    return 0;
  };
};
/**
 * Returns a {key: [...values]} pair for objects with the same key
 * @param {Object} collection
 * @param {String} property
 * @return {Object}
 */


exports.sortBy = sortBy;

var groupBy = function groupBy(collection, property) {
  var i = 0;
  var val;
  var index;
  var values = [];
  var result = [];

  for (; i < collection.length; i++) {
    val = collection[i][property];
    index = values.indexOf(val);

    if (index > -1) {
      result[index].push(collection[i]);
    } else {
      values.push(val);
      result.push([collection[i]]);
    }
  }

  return result;
};

exports.groupBy = groupBy;

//# sourceMappingURL=Utils.js.map